import { LogoCompact } from '../images';

export const WeaveLogo = () => {
  return <LogoCompact />;
};
